module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_vm._v(_vm._s(_vm.date) + " Mutual Success Lighting Fixtures Inc.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88d8c0f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 159
// module chunks = 0